import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import { StoreContext } from 'redux-react-hook';

import TrackingAPI from './api/TrackingAPI';
import RouterApp from './components/apps/RouterApp';
import { configureAppStore } from './store/configureAppStore';
import { initializeAxios } from './utils/initialization';

import './styles/tailwind.css';
import './styles/global.css';

import 'focus-visible';

ReactGA.initialize('G-X4E0XYMY87');

initializeAxios();

const preloadedState = window.__PRELOADED_STATE__;
const store = configureAppStore(preloadedState);
delete window.__PRELOADED_STATE__;
window.global = window;


const spinnerRoot = document.getElementById('spinner-root');
const mainRoot = document.getElementById('root');
const spinnerRootInstance = spinnerRoot ? ReactDOM.createRoot(spinnerRoot) : null;
const mainRootInstance = ReactDOM.createRoot(mainRoot);

function showContent() {
  if (mainRoot && spinnerRoot) {
    mainRoot.classList.add('visible');

    if (spinnerRootInstance) {
      spinnerRootInstance.unmount();
      spinnerRoot.remove();
    }
  }
}

TrackingAPI.runInfiniteTracking()
  .then(Function.prototype)
  .catch(Function.prototype); 


if (spinnerRootInstance) {
  spinnerRootInstance.render(
    <div className="fixed inset-0 bg-[rgba(16,_13,_11,_1)] z-50" />
  );
}

const app = (
  <React.StrictMode>
    <Provider store={store}>
      <StoreContext.Provider value={store}>
        <BrowserRouter>
          <Sentry.ErrorBoundary>
            <RouterApp />
          </Sentry.ErrorBoundary>
        </BrowserRouter>
      </StoreContext.Provider>
    </Provider>
  </React.StrictMode>
);


mainRootInstance.render(app);

window.requestAnimationFrame(() => {
  window.requestAnimationFrame(showContent);
}); 